/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListItemsForSubCategory$Params {
  SubCategoryId?: string;
}

export function listItemsForSubCategory(http: HttpClient, rootUrl: string, params?: ListItemsForSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listItemsForSubCategory.PATH, 'get');
  if (params) {
    rb.query('SubCategoryId', params.SubCategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listItemsForSubCategory.PATH = '/api/gmn/Menu/listitemsforsubcategory';
